/*
  We'll add a 30-min expiry (exp) so rooms won't linger too long on your account.
  See other available options at https://docs.daily.co/reference#create-room
 */
import { get, post } from '../../utils/api';

  async function createRoom() {
    const exp = Math.round(Date.now() / 1000) + 60 * 30;
    const options = {
      properties: {
        //potentially add back in exp if I want calls to expire
      //  exp,
        enable_prejoin_ui: false, // TODO: remove me when robots are no longer needed
      },
    };
  
    /*
      This endpoint is using the proxy as outlined in netlify.toml.
      Comment this out if you want to use the local option below.
    */
  //  const response = await fetch(`${window.location.origin}/api/rooms`, {
  //    method: "POST",
  //    body: JSON.stringify(options),
  //  });
  
    /*
      Uncomment the request below to test the "create room" functionality locally.
      Don't forget to comment out the request above, too!
    */
     const response = await fetch('https://api.daily.co/v1/rooms/', {
       method: 'POST',
       body: JSON.stringify(options),
       headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + process.env.REACT_APP_DAILY_API_KEY,
       },
     });

     const roomData = await response.json();
  
    //return await response.json();
    return roomData;
  }

  async function getRoomChild(childId, lessonScheduleId) {
    const idempotencyKey = `${childId}:${lessonScheduleId}:${Date.now()}`;
    const child = await get(`/children/${childId}`, true);
    const resolution = await post(
      '/lesson-schedules/join/resolve',
      {
        childId,
        lessonScheduleId,
        idempotencyKey,
      },
      true,
    );

    if (!resolution?.allowedRoom) {
      const requestId = resolution?.requestId ? ` (request ${resolution.requestId})` : '';
      throw new Error(`No classroom assignment available${requestId}`);
    }

    return {
      child,
      url: 'https://novalearning1.daily.co/' + resolution.allowedRoom,
      joinDecision: resolution,
      joinIdempotencyKey: idempotencyKey,
    };
  }

  async function confirmJoinRoom({
    childId,
    lessonScheduleId,
    joinVersionToken,
    idempotencyKey,
  }) {
    return post(
      '/lesson-schedules/join/confirm',
      {
        childId,
        lessonScheduleId,
        joinVersionToken,
        idempotencyKey,
      },
      true,
    );
  }

  
  

  // Verify that a pasted ?roomUrl=... link belongs to this logged-in parent's
  // assigned class AND that the account has access, before joining the room.
  // Returns { allowed, reason }.
  async function verifyRoomAccess(roomUrl) {
    return post('/lesson-schedules/join/verify-room', { roomUrl }, true);
  }

  // is it dangerous or problematic to make getRoomTutor async even though we're not making a call to the API?
  
  async function getRoomTutor(classroomName) {
    // Get the entire child object
    //console.log('classroom Name', classroomName);
    //const child = await get(`/children/${childId}`, true);

    // Then create the room
    /*const response = await fetch('https://api.daily.co/v1/rooms/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + process.env.REACT_APP_DAILY_API_KEY,
      },
    });

    const roomData = await response.json();*/
    
    // Return the allocated classroom from child data
    //console.log(child, child);
    return {
      //child: child,
      url: 'https://novalearning1.daily.co/'+ classroomName  // This will be used as the room URL
    };
  }
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default { createRoom, getRoomChild, getRoomTutor, confirmJoinRoom, verifyRoomAccess };